import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
// import image from "../PicesForPages/34615_interest_rate_cuts.jpg";

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetch(
      "https://script.google.com/macros/s/AKfycbwzZ8ZxzwZdv4wMrar8TCzUq29nwmoqzyQ_NK0KflrMKCOXQ7uVuCKGFpig1qGksNg/exec"
    )
      .then((res) => res.json())
      .then((data) => {
        const found = data.find((item) => String(item.id) === String(id));
        setProduct(found);
      })
      .catch((err) => console.error("Error:", err));
  }, [id]);

  if (!product) {
    return (
      <div style={styles.loadingContainer}>
        <p style={styles.loadingText}>Loading products...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{product.title} - Today USA Deals</title>
        <meta property="og:title" content={product.title} />
        <meta property="og:description" content={product.description} />
        <meta property="og:image" content={product.image_url} />
        {/* <meta property="og:image" content={image} /> */}
        <meta
          property="og:url"
          content={`https://todayusadeals.com/product/${product.id}`}
        />
        <meta property="og:type" content="product" />
      </Helmet>

      <div style={styles.container}>
        <div style={styles.card}>
          <img
            src={product.image_url}
            alt={product.title}
            style={styles.image}
          />
          <h2 style={styles.title}>{product.title}</h2>
          <p style={styles.description}>{product.description}</p>
          <p style={styles.category}>{product.category}</p>
          <p style={styles.price}>
            <span style={styles.currentPrice}>${product.current_price}</span>{" "}
            <span style={styles.originalPrice}>${product.original_price}</span>
          </p>
          <a
            href={product.affiliate_link}
            target="_blank"
            rel="noreferrer"
            style={styles.button}
          >
            Buy Now
          </a>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "2rem",
    display: "flex",
    justifyContent: "center",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
  },
  loadingText: {
    fontSize: "1.5rem",
    color: "#1976d2",
  },
  card: {
    maxWidth: "600px",
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "1.5rem",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
  },
  image: {
    width: "100%",
    borderRadius: "8px",
    marginBottom: "1rem",
  },
  title: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    margin: "0.5rem 0",
  },
  description: {
    fontSize: "1rem",
    color: "#555",
    marginBottom: "1rem",
  },
  category: {
    fontSize: "0.9rem",
    fontStyle: "italic",
    color: "#999",
  },
  price: {
    marginTop: "0.5rem",
    fontSize: "1.2rem",
  },
  currentPrice: {
    color: "#d32f2f",
    fontWeight: "bold",
  },
  originalPrice: {
    textDecoration: "line-through",
    marginLeft: "0.5rem",
    color: "#999",
  },
  button: {
    marginTop: "1.5rem",
    display: "inline-block",
    padding: "0.7rem 1.5rem",
    backgroundColor: "#1976d2",
    color: "#fff",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "bold",
  },
};

export default ProductDetails;
